<div class="mt-4">
  <app-header></app-header>
</div>
<nz-spin
  [nzSpinning]="loading"
  class="d-flex flex-column h-75 justify-content-center align-items-center"
>
  <div
    class="d-flex p-lg-5 flex-column h-75 justify-content-center align-items-center fileSaveContainer"
  >
    <p style="font-size: 30px">{{ 'file-download' | translate }}</p>
    <button nz-button nzType="primary" (click)="download()">
      <span nz-icon nzType="download"></span>{{ 'download-now' | translate }}
    </button>
  </div>
</nz-spin>
